import { render, staticRenderFns } from "./multi-screen.vue?vue&type=template&id=44311412&"
import script from "./multi-screen.vue?vue&type=script&lang=js&"
export * from "./multi-screen.vue?vue&type=script&lang=js&"
import style0 from "./multi-screen.vue?vue&type=style&index=0&id=44311412&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports